import { connect } from 'react-redux';
import { compose } from 'redux';

import ControlledComponent from '../components/Assessment'

function mapStateToProps(state, ownProps) {
  
    const { breadcrumbs,
        store, firebase: { auth, profile}  } = state
    
    return {
        breadcrumbs,
        store,
        auth, profile
    }
    
  }

export default compose(
    connect(
        mapStateToProps,null
      )
)(ControlledComponent)


// WEBPACK FOOTER //
// ./src/assessments/containers/Assessment.js